import { render, staticRenderFns } from "./riQuickInfo.vue?vue&type=template&id=41a12bde&"
import script from "./riQuickInfo.vue?vue&type=script&lang=js&"
export * from "./riQuickInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports